/**
 * Imported/aggregated events are carried through listing UIs as `Item`s with
 * an `imported-<slug>` id, but they live at /happening/<slug>, not /place/<id>.
 * Use this helper anywhere a card links to an item's detail page.
 */
export const IMPORTED_PREFIX = "imported-";

export function isImportedEventId(id: string | undefined | null): boolean {
  return typeof id === "string" && id.startsWith(IMPORTED_PREFIX);
}

export function importedEventSlug(id: string): string {
  return id.slice(IMPORTED_PREFIX.length);
}

/** Place slugs that are district hub cards (carousel / search), not venue pages. */
export const DISTRICT_HUB_PATHS: Record<string, "/train-factory"> = {
  "train-factory-hub": "/train-factory",
};

export const DISTRICT_HUB_TAG = "district-hub";

export function districtHubPath(id: string | undefined | null): "/train-factory" | null {
  if (!id) return null;
  return DISTRICT_HUB_PATHS[id] ?? null;
}

export function hasDistrictHubTag(tags: unknown): boolean {
  return Array.isArray(tags) && tags.includes(DISTRICT_HUB_TAG);
}

export function itemLinkProps(id: string, menuOnly = false):
  | { to: "/happening/$slug"; params: { slug: string } }
  | { to: "/menu/$slug"; params: { slug: string } }
  | { to: "/train-factory" }
  | { to: "/place/$id"; params: { id: string } } {
  if (isImportedEventId(id)) {
    return { to: "/happening/$slug", params: { slug: importedEventSlug(id) } };
  }
  const hub = districtHubPath(id);
  if (hub) return { to: hub };
  // Menu-only listings have no full place page — the menu IS the page.
  if (menuOnly) return { to: "/menu/$slug", params: { slug: id } };
  return { to: "/place/$id", params: { id } };
}
